import { useAnalytics } from "@codat/analytics";
import { DataTable as OrchardDataTable } from "@codat/orchard-ui";
import { DataTableProps as OrchardDataTableProps } from "@codat/orchard-ui/dist/es/components/DataTable";
import {
  DataDefinition,
  RowInfo,
} from "@codat/orchard-ui/dist/es/components/DataTable/types";
import React from "react";

interface DataTableProps<T extends DataDefinition[], K extends string>
  extends OrchardDataTableProps<T, K> {
  rowName: string;
  buildEventProperties?: (data: T) => Record<string, unknown>;
}

export function DataTable<T extends DataDefinition[], K extends string>(
  props: DataTableProps<T, K>
) {
  const { rowName, buildEventProperties, rowsInfo, ...dataTableProps } = props;
  const { sendEvent } = useAnalytics();

  const handleRowClickWithTracking = (
    rowInfo: RowInfo<T>,
    e?: React.MouseEvent<HTMLTableRowElement>
  ) => {
    const eventProperties = buildEventProperties
      ? buildEventProperties(rowInfo.data)
      : {};
    if (rowInfo.onClick) {
      sendEvent(`${rowName} Row - Click`, eventProperties);
      rowInfo.onClick(e);
    }
  };

  const rowInfoWithTracking = rowsInfo.map((rowInfo: RowInfo<T>) => {
    return {
      ...rowInfo,
      onClick: rowInfo.onClick
        ? (e?: React.MouseEvent<HTMLTableRowElement, MouseEvent>) =>
            handleRowClickWithTracking(rowInfo, e)
        : undefined,
    };
  });
  return (
    <OrchardDataTable {...dataTableProps} rowsInfo={rowInfoWithTracking} />
  );
}
